export enum CareerLevel {
    Auszubildender = "Auszubildende*r",
    Praktikum = "Praktikum",
    Studentin = "Student*in",
    Berufseinsteigerin = "Berufseinsteiger*in",
    MitBerufserfahrung = "Mit Berufserfahrung",
    LeitendmitPersonalverantwortung = "Leitend mit Personalverantwortung",
    Direktorin = "Direktor*in"
}
